import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as eventReducer from './event.reducer';

export const selectLicenseSlice = createFeatureSelector<eventReducer.State>(
    eventReducer.EventStore
);

export const getEventSlice = createSelector(
    selectLicenseSlice,
    (state) => state
);

export const getEventById = (props: { eventId: string }) =>
    createSelector(getEventSlice, (state: eventReducer.State) =>
        state?.eventData.id === props?.eventId ? state.eventData.event : null
    );

export const getEventStatus = () =>
    createSelector(
        getEventSlice,
        (state: eventReducer.State) => state.eventData.status
    );

export const getEventData = () =>
    createSelector(
        getEventSlice,
        (state: eventReducer.State) => state.eventData
    );

export const getOpportunityStatus = () =>
    createSelector(
        getEventSlice,
        (state: eventReducer.State) => state.opportunitiesData?.status
    );

export const getOpportunitiesData = () =>
    createSelector(
        getEventSlice,
        (state: eventReducer.State) => state.opportunitiesData
    );

export const getOpportunitiesById = (props: { eventId: string }) =>
    createSelector(getEventSlice, (state: eventReducer.State) =>
        state?.opportunitiesData.id === props?.eventId
            ? state.opportunitiesData.opportunities
            : null
    );

export const getKeyStatsStatus = () =>
    createSelector(
        getEventSlice,
        (state: eventReducer.State) => state.keyStatsData?.status
    );

export const getKeyStatsData = () =>
    createSelector(
        getEventSlice,
        (state: eventReducer.State) => state.keyStatsData
    );

export const getKeyStats = (props: { eventId: string }) =>
    createSelector(getEventSlice, (state: eventReducer.State) =>
        state?.keyStatsData.id === props?.eventId
            ? state.keyStatsData.keyStats
            : null
    );
